"use strict";


import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { IconGlyphicon, IconFontAwesome } from 'generics/icons';
import {  ViewAppIdIcon,  ViewItemIconic  } from 'components/commonAssets';
import MoneyUtil from 'components/moneyUtil';
import { spawnDialogWindow } from 'components/dialogHolder';
import {  TrivialDialog  } from 'components/trivialDialog';


class ViewDoubleSellErrorDialog extends React.Component  {
  onBackdropTouch()  {
    this.props.removeModal();
  }


  render()  {
    const {  removeModal,  } = this.props;
    return (<TrivialDialog
                prefixL10N={`DoubleSellErrorModal`}
                panelType="warning"
                onCloseButton={removeModal}
                onOkButton={removeModal}
                bodyIcon={<IconFontAwesome type="exclamation-triangle" size="3x" fixedWidth />}
                mixClasses={["view-messagebox-dialog"]}
              />);
  }
}

defineSimpleTerm("DoubleSellErrorModal.heading",  "Error",  {
    "ru_RU": "Ошибка",
    "cs_CZ": "Error",
    "fr_FR": "Erreur",
    "de_DE": "Fehler",
    "it_IT": "Errore",
    "ko_KR": "오류",
    "pl_PL": "Błąd",
    "pt_PT": "Error",
    "es_ES": "Error",
    "zh_CN": "错误",
    "zh_TW": "錯誤"
} );

defineSimpleTerm("DoubleSellErrorModal.prompt",  "Failed to sell current item",  {
    "ru_RU": "Возникла ошибка при выставлении ордера",
    "cs_CZ": "Failed to sell current item",
    "fr_FR": "Échec de la vente en cours de l'item",
    "de_DE": "Verkauf des aktuellen items gescheitert",
    "it_IT": "Vendita oggetto fallita",
    "ko_KR": "해당 아이템의 판매에 실패하였습니다",
    "pl_PL": "Nie udało się sprzedać tego przedmiotu",
    "pt_PT": "Failed to sell current item",
    "es_ES": "No se pudo vender el artículo actual",
    "zh_CN": "出售当前物品失败",
    "zh_TW": "出售當前物品失敗"
} );

defineSimpleTerm("DoubleSellErrorModal.explanation",  "Failed to place sell order, one of possible causes - item was sold or consumed ingame\nTry refresh page",  {
    "ru_RU": "Не удалось выставить этот товар на продажу\nОдна из возможных причин - он уже был продан или использован в игре\nПопробуйте обновить страницу",
    "cs_CZ": "Failed to place sell order, one of possible causes - item was sold or consumed ingame\nTry refresh page",
    "fr_FR": "Échec de l'émission de l'ordre de vente, une des causes possibles - l'article a été vendu ou consommé en jeu. \nEssayez d'actualiser la page",
    "de_DE": "Platzieren des Verkaufsauftrages gescheitert, einer der möglichen Gründe - Item wurde verkauft oder im Spiel verbraucht\nVersuche die Seite neu zu laden",
    "it_IT": "Non è stato possibile piazzare l'ordine di vendita, causa possibile - oggetto venduto o utilizzato in gioco\nProva ad aggiornare la pagina",
    "ko_KR": "판매 주문을 만드는 데 실패하였습니다. - 아이템이 이미 팔렸거나, 게임 내에서 소모되었는지 확인해 주시기 바랍니다.",
    "pl_PL": "Nie udało się wystawić polecenia sprzedaży, jedna z możliwych przyczyn to sprzedanie lub skonsumowanie w grze\nSpróbuj odświeżyć stronę",
    "pt_PT": "Failed to place sell order, one of possible causes - item was sold or consumed ingame\nTry refresh page",
    "es_ES": "No se pudo realizar el pedido de venta, una de las posibles causas - el artículo se vendió o se consumió en el juego\nPrueba refrescar la página",
    "zh_CN": "下达出售订单失败，可能的原因之一：物品已于游戏中售出或消耗\n请尝试刷新页面",
    "zh_TW": "下達出售訂單失敗，可能的原因之一：物品已於游戏中售出或消耗\n請嘗試重新整理頁面"
} );

defineSimpleTerm("DoubleSellErrorModal.okButton",  "OK",  {
    "ru_RU": "OK",
    "cs_CZ": "OK",
    "fr_FR": "OK",
    "de_DE": "OK",
    "it_IT": "OK",
    "ko_KR": "확인",
    "pl_PL": "OK",
    "pt_PT": "OK",
    "es_ES": "OK",
    "zh_CN": "确定",
    "zh_TW": "確定"
} );


class ViewOnBuyReserveFailDialog extends React.Component  {
  onBackdropTouch()  {
    this.props.removeModal();
  }


  render()  {
    const {  removeModal, amount, price, class_info  } = this.props;

    const market = SettingsInjections.getUsedCurrency().market;
    const priceText = MoneyUtil.formatMoney( price, market );
    const totalText = MoneyUtil.formatMoney( amount*price, market );

    return (<TrivialDialog
                prefixL10N={`OnBuyReserveFailModal`}
                panelType="warning"
                onCloseButton={removeModal}
                onOkButton={removeModal}
                bodyIcon={<IconFontAwesome type="exclamation-triangle" size="3x" fixedWidth />}
                mixClasses={["view-messagebox-dialog"]}
              >
              <ViewItemIconic classInfo={class_info} />
              <div>
                {_I_("OnBuyReserveFailModal.youNeed1")} <b> {amount} x {priceText} = {totalText} </b> {_I_("OnBuyReserveFailModal.youNeed2")}
              </div>
              <div>
                {_I_("OnBuyReserveFailModal.tryRefresh")}
              </div>
          </TrivialDialog>);
  }
}


defineSimpleTerm("OnBuyReserveFailModal.heading",  "Error",  {
    "ru_RU": "Ошибка",
    "cs_CZ": "Error",
    "fr_FR": "Erreur",
    "de_DE": "Fehler",
    "it_IT": "Errore",
    "ko_KR": "오류",
    "pl_PL": "Błąd",
    "pt_PT": "Error",
    "es_ES": "Error",
    "zh_CN": "错误",
    "zh_TW": "錯誤"
} );

defineSimpleTerm("OnBuyReserveFailModal.prompt",  "Failed to place buy order",  {
    "ru_RU": "Возникла ошибка при выставлении ордера",
    "cs_CZ": "Failed to place buy order",
    "fr_FR": "Echec de l'émission de l'ordre d'achat",
    "de_DE": "Kaufauftrag konnte nicht platziert werden",
    "it_IT": "Inserimento ordine d'acquisto fallito",
    "ko_KR": "아이템 구매에 실패하였습니다",
    "pl_PL": "Nie udało się wystawić polecenia zakupu",
    "pt_PT": "Failed to place buy order",
    "es_ES": "No se pudo realizar el pedido de compra",
    "zh_CN": "下达购买订单失败",
    "zh_TW": "下達購買訂單失敗"
} );

defineSimpleTerm("OnBuyReserveFailModal.explanation",  "Failed to issue an buy order, was unable to reserve money from wallet.",  {
    "ru_RU": "Ваш ордер на покупку не создан - не удалось зарезервировать необходимую сумму на счету",
    "cs_CZ": "Failed to issue an buy order, was unable to reserve money from wallet.",
    "fr_FR": "Échec de l'émission d'un ordre d'achat, impossible de retirer de l'argent du portefeuille.",
    "de_DE": "Erstellung eines Kaufauftrags gescheitert, nicht möglich Geld vom Wallet zu reservieren.",
    "it_IT": "Non è stato possibile piazzare l'ordine di d'acquisto, mancanza di fondi nel bilancio.",
    "ko_KR": "아이템 구매에 실패하였습니다, 가이진 코인이 부족합니다.",
    "pl_PL": "Nie udało się wystawić polecenia zakupu, nie udało się zarezerwować pieniędzy z portfela.",
    "pt_PT": "Failed to issue an buy order, was unable to reserve money from wallet.",
    "es_ES": "No se pudo emitir una orden de compra, no se pudo reservar dinero de la billetera.",
    "zh_CN": "提出购买订单失败，无法从钱包中保留金钱。",
    "zh_TW": "提出購買訂單失敗，無法從錢包中保留金錢。"
} );

defineSimpleTerm("OnBuyReserveFailModal.youNeed1", "You need at least",  {
    "ru_RU": "Необходимо иметь не менее",
    "cs_CZ": "You need at least",
    "fr_FR": "Vous avez besoin d'au moins",
    "de_DE": "Du brauchst mindestens",
    "it_IT": "Ti serve almeno",
    "ko_KR": "적어도 다음의 가이진 코인을 확보하여",
    "pl_PL": "Potrzebujesz przynajmniej",
    "pt_PT": "You need at least",
    "es_ES": "Necesitas al menos",
    "zh_CN": "你需要至少",
    "zh_TW": "你需要至少"
} );

defineSimpleTerm("OnBuyReserveFailModal.youNeed2", "for this operation",  {
    "ru_RU": "на счету для этой операции",
    "cs_CZ": "for this operation",
    "fr_FR": "pour cette opération",
    "de_DE": "für diese Transaktion",
    "it_IT": "per questa operazione",
    "ko_KR": "이 작업을 실행하여 주십시오",
    "pl_PL": "dla tej operacji",
    "pt_PT": "for this operation",
    "es_ES": "para esta operación",
    "zh_CN": "才能进行此操作",
    "zh_TW": "才能進行此操作"
} );

defineSimpleTerm("OnBuyReserveFailModal.tryRefresh", "Try refresh page and ensure you have sufficent funds",  {
    "ru_RU": "Убедитесь что в кошельке достаточно средств и обновите страницу",
    "cs_CZ": "Try refresh page and ensure you have sufficent funds",
    "fr_FR": "Essayez d'actualiser la page et assurez-vous d'avoir suffisamment de fonds",
    "de_DE": "Um die Seite neu zu laden bitte gehe sicher genug Mittel zu haben",
    "it_IT": "Prova ad aggiornare la pagina ed assicurati di avere i fondi necessari",
    "ko_KR": "충분한 가이진 코인이 있는지 확인한 후 페이지를 새로고침 하여 주십시오",
    "pl_PL": "Spróbuj odświeżyć stronę i upewnij się, ze masz wystarczające fundusze",
    "pt_PT": "Try refresh page and ensure you have sufficent funds",
    "es_ES": "Intenta actualizar la página y asegúrate de tener fondos suficientes",
    "zh_CN": "请尝试刷新页面，并确保拥有足够资金",
    "zh_TW": "請嘗試重新整理頁面，並確保擁有足夠資金"
} );

defineSimpleTerm("OnBuyReserveFailModal.okButton",  "OK",  {
    "ru_RU": "OK",
    "cs_CZ": "OK",
    "fr_FR": "OK",
    "de_DE": "OK",
    "it_IT": "OK",
    "ko_KR": "확인",
    "pl_PL": "OK",
    "pt_PT": "OK",
    "es_ES": "OK",
    "zh_CN": "确定",
    "zh_TW": "確定"
} );


export function spawnDoubleSellErrorModal()  {
  spawnDialogWindow(ViewDoubleSellErrorDialog,  {});
}


export function spawnOnBuyReserveFailDialog( appid, hash_name, class_info, amount, price )  {
  spawnDialogWindow(ViewOnBuyReserveFailDialog,  {
      appid,  hash_name,  class_info,  amount,  price,
    });
}

